import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store/store.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

import moment from "moment";
moment.locale("en");
Vue.prototype.$moment = moment;

import constPlugin from "./util/constant.js";
Vue.use(constPlugin);

import funcPlugin from "./util/functions.js";
Vue.use(funcPlugin);

import user from "./store/user.js";
Vue.prototype.$user = user;

import money from "v-money";
Vue.use(money, {
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: " VND",
  precision: 0,
  masked: false,
});

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);

const httpUrl = "https://spp-api.scancom.net";
import Axios from "axios";
Vue.prototype.$http = Axios.create({
  //baseURL: "https://localhost:5001",
  baseURL: httpUrl,
  timeout: 120000,
});

Vue.prototype.$http.interceptors.request.use(
  (config) => {
    const userStr = Vue.prototype.$func.getCookie("user-scancom");
    if (userStr) {
      let user = JSON.parse(userStr);
      config.headers["Authorization"] = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import VueSweetalert2 from "vue-sweetalert2";
// // If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import { Settings as LuxonSettings } from "luxon";
LuxonSettings.defaultLocale = "en-us";

import messageHub from "./message-hub";
Vue.use(messageHub);

import VueLazyload from "vue-lazyload";
// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "img/error.png",
  loading: "img/loading.gif",
  attempt: 1,
});

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  components: {
    App,
  },
});
